import React from "react";
import styles from "./RideDetails.module.scss";
import NetworkService from "../NetworkService";
import { useSearchParams } from "react-router-dom";
import {
  RIDE_PHASE,
  getRidePhase,
  isTerminalPhase,
  shouldShowDriver,
  shouldShowPickupEta,
} from "../rideStatus";
import { getScheduledRideInfo } from "../scheduledRideUtils";
import ScheduledRideInfo from "./ScheduledRideInfo";

function RideDetails({ rideDetails }) {
  const [searchParams] = useSearchParams();
  const phase = getRidePhase(rideDetails);
  const showDriver = shouldShowDriver(rideDetails);
  const scheduledInfo = getScheduledRideInfo(rideDetails);

  return (
    <div className={styles.detailsWrap}>
      {isTerminalPhase(phase) && <div className={styles.singleHeader}>Thank you for using our Service</div>}

      {phase === RIDE_PHASE.SCHEDULED && !showDriver && (
        <div className={styles.scheduledHeader}>
          <div className={styles.header}>Your ride is scheduled and is on review!</div>
          <p className={styles.scheduledText}>Our customer support will review your service and approve.</p>
          <p className={styles.scheduledText}>Thank You for using our services!</p>
        </div>
      )}

      {phase === RIDE_PHASE.SCHEDULED && showDriver && (
        <div className={styles.scheduledHeader}>
          <div className={styles.header}>Your scheduled ride is confirmed!</div>
          <p className={styles.scheduledText}>Review your info below.</p>
          <p className={styles.scheduledText}>Thanks for using our services!</p>
        </div>
      )}

      {phase === RIDE_PHASE.SCHEDULED && <ScheduledRideInfo scheduledInfo={scheduledInfo} />}

      {shouldShowPickupEta(rideDetails) && (
        <div className={styles.headerNotPickedUp}>
          <div className={styles.textWrap}>
            <div className={styles.header}>Thank you for using our Service</div>
            <div className={styles.subHeader}>Estimated pickup time: </div>
          </div>

          <div className={styles.timeLeft}>
            <div className={styles.time}>{rideDetails.pickup_time}</div>
            <div className={styles.minLabel}>min</div>
          </div>
        </div>
      )}

      {phase === RIDE_PHASE.ARRIVED && <div className={styles.singleHeader}>Your driver has arrived</div>}

      {phase === RIDE_PHASE.IN_PROGRESS && <div className={styles.singleHeader}>Enjoy your ride</div>}

      {phase === RIDE_PHASE.SEARCHING && (
        <div className={styles.searchingHeader}>
          <div className={styles.header}>Searching for a driver</div>
          <div className={styles.subHeader}>We're finding a driver for your ride</div>
        </div>
      )}

      {showDriver && (
        <>
          <div className={styles.carDetails}>
            <div className={styles.imagesWrap}>
              {rideDetails?.driver_image && (
                <img alt="driver img" className={styles.driverImage} src={rideDetails.driver_image} />
              )}
              {rideDetails?.car_image && (
                <img alt="car img" className={styles.carImage} src={rideDetails.car_image} />
              )}
            </div>

            <div className={styles.modelAndPlates}>
              {rideDetails?.car_model && <div className={styles.model}>{rideDetails.car_model}</div>}
              {rideDetails?.plates && <b className={styles.plates}>{rideDetails.plates}</b>}
            </div>
          </div>

          <div className={styles.driverNameAndPhone}>
            <div className={styles.driverName}>
              {rideDetails?.driver_name}
              {(rideDetails?.driver_rate != null || rideDetails?.driver_rides_count != null) && (
                <div className={styles.ratingAndDriveCount}>
                  <img alt="" className={styles.driverInfoIcons} src="/ic_rate.svg" />
                  <span>{rideDetails?.driver_rate}</span>
                  <img alt="" className={styles.driverInfoIcons} src="/ic_rides.svg" />
                  <span>{rideDetails?.driver_rides_count}</span>
                </div>
              )}
            </div>
            {rideDetails?.contact_id && (
              <div
                className={styles.callButton}
                onClick={() => {
                  NetworkService.createPhoneConnection(searchParams.get("token"), rideDetails?.id)
                    .then((res) => {
                      console.log(res);
                      if (res?.success && res?.phone) {
                        window.location.href = `tel:${res.phone}`;
                      }
                    })
                    .catch((err) => console.error(err));
                }}>
                <img className={styles.phoneIcon} alt="phone icon" src="/btn_call.svg" />
                Call service provider
              </div>
            )}
          </div>
        </>
      )}
      <LocationSegment rideDetails={rideDetails} />
    </div>
  );
}

export default RideDetails;

export const LocationSegment = ({ rideDetails }) => {
  return (
    <div className={styles.locationSegment}>
      <div className={styles.startAddress}>
        <img className={styles.locationImages} src="/pin_from.svg" />
        {rideDetails?.location}
      </div>
      {rideDetails?.waypoints?.map((waypoint, index) => (
        <div key={index} className={styles.waypoint}>
          <img className={styles.locationImages} src="/ic_24_stop_pin2.svg" />
          {waypoint.address}
        </div>
      ))}
      <div className={styles.endAddress}>
        <img className={styles.locationImages} src="/destination_pin2.svg" />
        {rideDetails?.destination}
      </div>
    </div>
  );
};
